module.exports = __webpack_public_path__ + "img/orange-dot.b41b596f.svg";